// 打开coupon大转盘弹窗
export const COOKIE_COUPON_WHEEL_MODAL_DISPLAYED = 'COUPON_WHEEL_MODAL_DISPLAYED'

// 未登录状态保存抽奖结果id
export const COOKIE_COUPON_WHEEL_RESULT_UNIQUE_ID = 'COUPON_WHEEL_RESULT_UNIQUE_ID'

//
export const COOKIE_COUPON_WHEEL_MINI_ENTRANCE_HIDE= 'COUPON_WHEEL_MINI_ENTRANCE_HIDE'